import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import SEO from '../components/seo'
import SingleExam from '../components/single-exam'

const Exam = ({ data, location, pageContext }) => {
  const exam = data.exams
  const wordpressData = data.wordpressWpGatsbyPage.acf
  const examCanonical = `${wordpressData.canonical + exam.slug}/`

   const listsLinksSiteAndBlog = useMemo(() =>{
      const linksBlog = [];
      const linksSite = [];
  
      Object.entries(wordpressData).forEach(([key, value]) => {
  
        if(key.startsWith("link_site")){
          linksSite.push(value)
        }
        else if( key.startsWith("link_blog") ){
          linksBlog.push(value)
        }
  
      })
  
      return { linksBlog,linksSite };
  
    }, [wordpressData])

  return (
    <Layout location={location} pageContext={pageContext} crumbLabel={exam.name}>
      <SEO
        title={exam.name}
        description={`${exam.name} Informações completas sobre o exame, orientações gerais, genes analisados e doenças relacionadas.`}
        canonical={examCanonical}
      />

      <SingleExam
        exam={exam}
        data={data}
        listLinks={listsLinksSiteAndBlog}
        location={pageContext.breadcrumb.location}      
      />
    </Layout>
  )
}

Exam.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array,
  location: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export default Exam

export const unitQuery = graphql`
  query($id: String!, $slug: String!) {
    exams(id: { eq: $id }) {
      id
      name
      specializationProduct {
        areaEspecializacao {
          nome
        }
      }
      category {
        id
        nome
      }
      diseases
      synonymies
      deadline
      ansCover
      genes
      informativeProduct {
        descricao
        metodo
        objetivo
      }
      preparation {
        descricao
      }
      material {
        nome
        id
      }
      materials {
        nome
        id
      }
      tussCode
      documents {
        name
        url
        id
      }
      showGeneCount
      slug
      vertical {
        id
        nome
        processos {
          descricao
          id
        }
      }
    }
    site {
      id
      siteMetadata {
        title
        subtitle
      }
    }
    wordpressWpGatsbyPage(slug: { eq: $slug }) {
      acf {
        canonical
        ans_label_exam_details
        others_names_exam_details
        title_diseases_section
        title_deadline_section
        description_deadline
        title_ans_coverage_section
        description_not_coverage_ans
        description_coverage_ans
        title_section_analyzed_genes
        description_section_analyzed_genes
        title_btn_copy_genes
        text_tooltip_copy_genes
        text_counter_genes
        title_btn_all_genes
        title_modal_genes
        title_btn_clone_modal_genes
        text_no_results
        title_appointment_flow
        description_appointment_flow
        schedule_exams_btn
        show_schedule_exams_btn
        btn_title_nav_appointment
        btn_link_nav_appointment
        btn_icon_nav_appointment
        btn_title_whatsapp_appointment
        btn_msg_whatsapp_appointment
        btn_link_whatsapp_appointment
        btn_icon_whatsapp_appointment
        show_collection_flow
        imagem_detalhamento_exame {
          alt_text
          localFile {
            childImageSharp {
              fluid(quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        texto_de_oque_e_exame
        texto_de_para_que_serve_exame
        texto_de_documentos_necessarios
        texto_de_preparo
        texto_de_tipo_de_amostra
        texto_de_metodologia
        texto_de_codigo_tuss
        text_link_site0
        link_site1  
        link_site2  
        link_site3  
        link_site4  
        link_site5  
        link_site6  
        link_site7  
        link_site8  
        link_site9  
        link_site10  
        link_site11  
        link_site12  
        link_site13  
        link_site14  
        link_site15  
        link_site16  
        link_site17  
        link_site18  
        link_site19  
        link_site20  
        link_blog1  
        link_blog2  
        link_blog3  
        link_blog4  
        link_blog5  
        link_blog6  
        link_blog7  
        link_blog8  
        link_blog9  
        link_blog10  
        link_blog11  
        link_blog12  
        link_blog13  
        link_blog14  
        link_blog15  
        link_blog16  
        link_blog17  
        link_blog18  
        link_blog19  
        link_blog20
        text_link_site_dasaeduca
        link_site_dasaeduca
        link_exame_dasa_educa_1
        link_exame_dasa_educa_2
        link_exame_dasa_educa_3
        link_exame_dasa_educa_4
        link_exame_dasa_educa_5
        link_exame_dasa_educa_6
        link_exame_dasa_educa_7
        link_exame_dasa_educa_8
        link_exame_dasa_educa_9
        link_exame_dasa_educa_10
        link_exame_dasa_educa_11
        link_exame_dasa_educa_12
        link_exame_dasa_educa_13
        link_exame_dasa_educa_14
        link_exame_dasa_educa_15
        link_exame_dasa_educa_16
        link_exame_dasa_educa_17
        link_exame_dasa_educa_18
        link_exame_dasa_educa_19
        link_exame_dasa_educa_20
      }
    }
  }
`
